import { Auth } from "@graphapi-io/customer-components";
import { AuthStateHandler } from "./auth-state-handler";
import { UserDataLoader } from "./user-data-loader";
import { getDefaultAuthConfig } from "./get-auth-config";

export const auth = new Auth(getDefaultAuthConfig());
export const userDataLoader = new UserDataLoader(new AuthStateHandler(auth));
